import { fromJSX, none, nothing, Option, Updater, Widget } from 'widgets-for-react'
import { getCtaBlockLayoutFromContactPerson } from '../cmsPage/blocks/ctaBlockLayout'
import {
  CasePage,
  DossierPage,
  KnowledgeArticlePage,
  PageWithBlocks,
  PageWithBlocksState
} from '../cmsPage/cmsPageState'
import { ContactPersonData } from '../cmsPage/sharepointPageApi/types/pageData'

const getContactPerson = (
  data: KnowledgeArticlePage | DossierPage | CasePage
): Option<ContactPersonData> => {
  if (data.contactPerson.kind === 'r') {
    return data.contactPerson
  }
  if (data.kind === 'knowledge-article' && data.primaryDossier.kind === 'r') {
    return getContactPerson(data.primaryDossier.v)
  }
  if (data.kind === 'dossier' && data.primaryDossier.kind === 'r') {
    return getContactPerson(data.primaryDossier.v)
  }
  return none()
}
export const contentFooterWidget = (
  page: PageWithBlocks
): Widget<Updater<PageWithBlocksState>> => {
  switch (page.kind) {
    case 'home':
      return nothing()
    case 'dossier':
      return fromJSX(() =>
        getCtaBlockLayoutFromContactPerson(getContactPerson(page))
      )
    case 'generic':
      return nothing()
    case 'knowledge-article':
      return fromJSX(() =>
        getCtaBlockLayoutFromContactPerson(getContactPerson(page))
      )
    case 'event':
      return nothing()
    case 'article':
      return nothing()
    case 'knowledge-overview':
      return nothing()
    case 'course-category':
      return nothing()
    case 'course-group':
      return nothing()
    case 'course-details':
      return nothing()
    case 'actuality-details':
      return nothing()
    case 'case-detail':
      return fromJSX(() =>
        getCtaBlockLayoutFromContactPerson(getContactPerson(page))
      )
  }
}

// [Custom content types]: Add case here
